export default __webpack_public_path__ + "static/media/continue.3d4209cf.png";